import React, { FunctionComponent } from 'react';
import { getShopInfosInStorage } from './ShopInfos';
import { TranslationProps, WithTranslation } from '../../contexts/TranslationContext';
import { ItemCart } from './iCart';

interface RenderFrancoPortProps extends TranslationProps {
  francoAtteint?: boolean;
  francoNonAtteintRestant?: number;
  franco?: number;
  items: ItemCart[];
}

const RenderFrancoPortComponent: FunctionComponent<RenderFrancoPortProps> = ({franco, francoAtteint, francoNonAtteintRestant, textsContent, items}): JSX.Element => {
  const shopInfos = getShopInfosInStorage();

  const onlyVierge = items.filter(elt => parseInt(elt.marquage?.id || '0') > 0).length === 0;
  const shopIsOk = shopInfos.Ref === 'MT' || shopInfos.Ref === 'DT' || (shopInfos.Ref === 'TH' && onlyVierge && shopInfos.enable_franco);

  const isNotDeixo = (): boolean => {
    return !window.location.hostname.includes('deixo');
  };

  const getPathImage = () => {
    if(shopInfos.Ref === 'MT') {
      return '/images/refonte2014/picto-franco.png';
    } else if (shopInfos.Ref === 'TH') {
      return '/lib/images/picto-franco.png';
    } else {
      return '/images/picto-franco.png';
    }
  }

  const getInfoFreeDelivery = (): string|undefined => {
    let resultText: string|undefined = undefined;
    if (shopIsOk && francoAtteint) {
      resultText = textsContent?.['CART_FREE_DELIVERY_AVAILABLE'];
    } else if (shopIsOk && !francoAtteint && francoNonAtteintRestant && francoNonAtteintRestant > 0 ) {
      const montantRestant = parseFloat(francoNonAtteintRestant.toFixed(2)).toLocaleString() + '€';
      resultText = textsContent?.['CART_FREE_DELIVERY_NOT_AVAILABLE']?.replace('  ', ` ${montantRestant} `);
    }
    return resultText;
  }

  const francoStr =  franco ? franco.toFixed(2) : '';

  return (
    <div className="font14  border-top lineheight1 w100">
      {shopIsOk && isNotDeixo() && (
        <div className="d-flex mt1 mb1">
          <img src={getPathImage()} className="display-inlineblock mr1 mr-3 alignTop" alt="" width="47" height="47"/>
          <div className="ml1 d-flex flex-column justify-content-center">
            <p className="bold small mb0">
              {getInfoFreeDelivery()}<sup>*</sup>
            </p>
            <p className="italic display-block very-small mb0">
              <sup>* </sup>
              {textsContent?.['CART_FREE_DELIVERY_EXPLAIN']?.replace('  ', ` ${francoStr}€`)}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export const RenderFrancoPort = WithTranslation<RenderFrancoPortProps>(RenderFrancoPortComponent, 'CART_TUNNEL');
